import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../common/Header/Header';
import ErrorAlert from '../../../common/Alert/ErrorAlert';
import SuccessAlert from '../../../common/Alert/SuccessAlert';

const identity_host = process.env.REACT_APP_IDENTITY_HOST;

const MentorshipGoogleCalendar = ({ islogin, csrf }) => {
    const [iserror, setIsError] = useState(false);
    const [issuccess, setIsSuccess] = useState(false);
    const [message, setMessage] = useState("");
    const [projectId, setProjectId] = useState("");

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const projectIdFromURL = params.get("project_id");

        if (projectIdFromURL) {
            setProjectId(projectIdFromURL);
            setTimeout(() => {
                handleCalendarInitiation(projectIdFromURL);
            }, 100);
        }
    }, [location]);

    const handleCalendarInitiation = (projectIdToUse) => {
        const url = `${identity_host}/api/calendar/google-calendar-initiate/?project_id=${projectIdToUse}`;
        window.location.assign(url);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!projectId) {
            setIsError(true);
            setMessage("Please enter project ID.");
            setTimeout(() => {
                setIsError(false);
                setMessage("");
            }, 5000);
            return;
        }

        navigate(`/av-admin/mentorship-google-calendar/?project_id=${projectId}`);
    };

    return (
        <>
            <Header />
            {iserror && <ErrorAlert message={message} setIsError={setIsError} />}
            {issuccess && <SuccessAlert message={"Success Message"} />}
            <section id='googleCalendar' className='common-style background-dark-primary min-vh-100'>
                <div className='container py-5 px-5'>
                    <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-lg-8'>
                            <div className='card p-4 border-0 shadow background-dark-tertiary'>
                                <div className="card-body">
                                    <h3 className="card-title text-center mb-3 text-white fw-bold text-uppercase">
                                        Mentorship Google Calendar
                                    </h3>
                                    <form className='w-100' onSubmit={handleSubmit}>
                                        <div className="form-group mb-3">
                                            <label className="text-white">Project ID <sup className='text-danger'>*</sup></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder='Project ID'
                                                value={projectId}
                                                onChange={(event) => setProjectId(event.target.value)}
                                            />
                                        </div>
                                        <button type="submit" className='btn btn-dark btn-dark-primary px-5 py-2 mt-3 text-uppercase fw-bold w-100'>
                                            Continue
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

const mapStateToProps = (state) => ({
    csrf: state.LoginModalReducer.csrf,
    islogin: state.LoginModalReducer.islogin,
});

export default connect(mapStateToProps)(MentorshipGoogleCalendar);
